/**
 * Verbose debug logging, off by default.
 *
 * Debug output (WebSocket lifecycle, live-match events, API call traces) is
 * printed only in a development build AND when the debug flag is on:
 *   - REACT_APP_DEBUG=true in frontend/.env, or
 *   - localStorage.setItem("sportifide_debug", "1") in the browser console.
 *
 * Real problems should still use console.error / console.warn directly.
 */

export const DEBUG_STORAGE_KEY = "sportifide_debug";

export function isDebugEnabled() {
  if (process.env.NODE_ENV !== "development") return false;
  if (process.env.REACT_APP_DEBUG === "true") return true;
  try {
    return typeof window !== "undefined" && window.localStorage?.getItem(DEBUG_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function debugLog(...args) {
  if (isDebugEnabled()) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
}

const debug = { isDebugEnabled, debugLog };
export default debug;
